import {
  ContactMail,
  LocationCity,
  RoomService,
  Translate,
  Tune,
  Workspaces,
} from "@mui/icons-material";
import Icons from "icons/sidebar";

const index = [
  {
    title: "Dashboard",
    Icon: Icons.DashboardIcon,
    path: "/dashboard",
  },
  {
    title: "Service Providers",
    Icon: Icons.AddUserIcon,
    path: "/dashboard/service-providers",
  },
  {
    title: "Beneficiaries",
    Icon: Icons.UserProfileIcon,
    path: "/dashboard/beneficiaries",
  },
  {
    title: "Services",
    Icon: RoomService,
    path: "/dashboard/services",
  },
  {
    title: "Orders",
    Icon: Icons.UserManagementIcon,
    path: "/dashboard/orders",
  },
  {
    title: "Cities",
    Icon: LocationCity,
    path: "/dashboard/cities",
  },
  {
    title: "Reports",
    Icon: Tune,
    path: "/dashboard/reports",
  },
  {
    title: "How It Works",
    Icon: Workspaces,
    path: "/dashboard/how-it-works",
  },
  {
    title: "Languages",
    Icon: Translate,
    path: "/dashboard/languages",
  },
  {
    title: "Support",
    Icon: ContactMail,
    path: "/dashboard/support",
  },
];

export default index;
